import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable()
export class NavigationService {
  constructor(private router: Router) { }

  goTOProductview(id: string, actionInfo: number) {
    this.router.navigate(["/product/0/" + id, actionInfo]);
  }

  goTOProductview1(id: number, year: number, actionInfo: number) {
    this.router.navigate(["/product/0/" + id, year, actionInfo]);
  }

  goTOManufacturer(id: string, actionInfo: number) {
    this.router.navigate(["/manufacturer/" + id, actionInfo]);
  }

  goTOManufacturerDetail(id: string, actionInfo: number) {
    this.router.navigate(["/manufacturerdetail/" + id, actionInfo]);
  }

  goTOUserfbDetails(id: number, actionInfo: number) {
    this.router.navigate(["/userfbdetails/" + id, actionInfo]);
  }

  goToDepartment(id: string, actionInfo: number) {
    this.router.navigate(["/department/" + id, actionInfo]);
  }

  goToComponent(id: string, actionInfo: number) {
    this.router.navigate(["/dbtcomponent/" + id, actionInfo]);
  }

  goToGO(id: string, actionInfo: number) {
    this.router.navigate(["/dbtgo/" + id, actionInfo]);
  }
  goToproductcompmapping(id: number, actionInfo: number) {
    this.router.navigate(["/productcompmapping/" + id, actionInfo]);
  }

  goToDbtProductConfig(id: string, actionInfo: number) {
    this.router.navigate(["/configdbtproduct/" + id, actionInfo]);
  }

  goToDbtProductsubsitymap(id: string, actionInfo: number) {
    this.router.navigate(["/subsidydbtproduct/" + id, actionInfo]);
  }

  goToDbtScheme(id: string, actionInfo: number) {
    this.router.navigate(["/dbtscheme/" + id, actionInfo]);
  }

  goTOStateleveltarget(id: number) {
    this.router.navigate(["/statetargetlist/" + id]);
  }
  goTOStateleveltargetlist() {
    this.router.navigate(["/statetarget/"]);
  }
  goTOvillageleveltarget(id: number) {
    this.router.navigate(["/villageleveltarget/" + id]);
  }
  goTOsubdivisionleveltarget(id: number) {
    this.router.navigate(["/subdivisiontargetlist/" + id]);
  }
  goTosubdivisiontarget() {
    this.router.navigate(["/subdivisiontarget/"]);
  }
  goTovillageleveltarget() {
    this.router.navigate(["/villagetarget/"]);
  }
  goToDivisionLevelTarget(id: number) {
    this.router.navigate(["/divisionleveltarget/" + id]);
  }
  goToDistLelev() {
    this.router.navigate(["/divisiontarget/"]);
  }
  goTodivisionTargetList() {
    this.router.navigate(["/divisiontargetlist/"]);
  }
  goToSubdivisionTargetList() {
    this.router.navigate(["/subdivisiontargetlist/"]);
  }
  goTogpsdashboard() {
    this.router.navigate(["/gpsdownload/"]);
  }
  goToDealerInfo() {
    this.router.navigate(["/dealerinfo/"]);
  }
  gotoProductAdd(
    id: number,
    actionInfo: number,
    product: number,
    classification: number,
    categoryType: number
  ) {
    this.router.navigate([
      "/product/0/" + id,
      actionInfo,
      product,
      classification,
      categoryType,
    ]);
  }

  gotoDealer() {
    this.router.navigate(["/dealer"]);
  }

  gotoProduct(id: number) {
    this.router.navigate(["/product/" + id]);
  }

  goToDashboard() {
    this.router.navigate(["/dashboard"]);
  }
  goToRealTimeTracking() {
    this.router.navigate(["/realtimetracking"]);
  }
  goToMhireDashboard() {
    this.router.navigate(["/mhiredashboard"]);
  }
  goToLogin() {
    // this.router.navigate(['/login']);
    this.router.navigate(["/auth/login"]);
  }

  goToUnAuthorized() {
    this.router.navigate(["/unauthorized"]);
  }

  goToSessionTimedOut() {
    this.router.navigate(["/sessiontimedout"]);
  }

  isOnLoginScreen(): boolean {
    return this.router.url === "/login";
  }

  goToLiveTrack(id: string) {
    this.router.navigate(["/livetrack/" + id]);
  }
  goToLiveCharts(id: string) {
    this.router.navigate(["/realtimecharts/" + id]);
  }
  goToLiveTrackOverview() {
    this.router.navigate(["/livetrack"]);
  }

  goToVehicle(id: string, actionInfo: number) {
    this.router.navigate(["/vehicles/" + id, actionInfo]);
  }

  goToDriver(id: string, actionInfo: number) {
    this.router.navigate(["/drivers/" + id, actionInfo]);
  }
  goToGeologist(id: string, actionInfo: number) {
    this.router.navigate(["/geologist/" + id, actionInfo]);
  }
  goToUserfb(id: number, actionInfo: number) {
    this.router.navigate(["/userfeedbackhistory/" + id, actionInfo]);
  }
  goToFuelLog(id: string, actionInfo: number) {
    this.router.navigate(["/fuellog/" + id, actionInfo]);
  }

  goToFarmerEntries(id: number, actionInfo: number) {
    this.router.navigate(["/farmerentries/" + id, actionInfo]);
  }

  goToUser(id: string, actionInfo: number) {
    this.router.navigate(["/users/" + id, actionInfo]);
  }
  goToPACCSuser(id: string, actionInfo: number) {
    this.router.navigate(["/paccsusers/" + id, actionInfo]);
  }

  goToProfile(actionInfo: number) {
    this.router.navigate(["/profile/" + actionInfo]);
  }
  goToVehicleGroup(id: number, actionInfo: number) {
    this.router.navigate(["/vehiclegroups/" + id, actionInfo]);
  }

  goToServiceSchedule(id: string, actionInfo: number) {
    this.router.navigate(["/serviceschedules/" + id, actionInfo]);
  }

  goToInsurance(id: number) {
    this.router.navigate(["/insurancepopup/" + id]);
  }
  goToServiceLog(
    id: string,
    actionInfo: number,
    pagetype: string,
    status: number
  ) {
    this.router.navigate(["/servicelog/" + id, actionInfo, pagetype, status]);
  }
  goToDevice(id: string, actionInfo: number) {
    this.router.navigate(["/devices/" + id, actionInfo]);
  }
  goToProvider(id: string, actionInfo: number) {
    this.router.navigate(["/providers/" + id, actionInfo]);
  }
  goToTripsimulation(data: any) {
    this.router.navigate(["/tripsimulationreport/" + data]);
  }

  goToRegion(id: string, actionInfo: number) {
    this.router.navigate(["/regions/" + id, actionInfo]);
  }
  goToDivision(id: string, actionInfo: number) {
    this.router.navigate(["/divisions/" + id, actionInfo]);
  }
  goToImplementscategory(id: string, actionInfo: number) {
    this.router.navigate(["/implementscategory/" + id, actionInfo]);
  }
  goToGrampanchayat(id: number, actionInfo: number) {
    this.router.navigate(["/gramapanchayat/" + id, actionInfo]);
  }
  goToSubDivision(id: string, actionInfo: number) {
    this.router.navigate(["/subdivisions/" + id, actionInfo]);
  }
  goToBlock(id: string, actionInfo: number) {
    this.router.navigate(["/blocks/" + id, actionInfo]);
  }
  gotToBlockLevel(regionId: string, divisionId: string, blockId: string) {
    this.router.navigate(["/blockLevelTarget/", regionId, divisionId, blockId]);
  }
  goToDealer(id: number, actionInfo: number) {
    this.router.navigate(["/dealer/" + id, actionInfo]);
  }
  goToCashBooking() {
    this.router.navigate(["/cashbooking/"]);
  }
  goToNewCashBooking(id: number, actionInfo: number) {
    this.router.navigate(["/cashbooking/" + id, actionInfo]);
  }
  goToViewCashBooking(id: number) {
    this.router.navigate(["/cashbooking/" + id]);
  }
  goToWorkshops(id: string, actionInfo: number) {
    this.router.navigate(["/workshops/" + id, actionInfo]);
  }
  goToImplement(id: string, actionInfo: number) {
    this.router.navigate(["/implements/" + id, actionInfo]);
  }
  goToBankdetails(id: string, actionInfo: number, name: any) {
    this.router.navigate(["/bankname/" + id, actionInfo, name]);
  }
  goToCity(id: number, actionInfo: number) {
    this.router.navigate(["/bankcity/" + id, actionInfo]);
  }
  goToTarrif(id: string, actionInfo: number) {
    this.router.navigate(["/tariffs/" + id, actionInfo]);
  }
  goToTripEntry(
    id: number,
    actionInfo: number,
    approveTrue: boolean,
    pageType: number
  ) {
    this.router.navigate([
      "/tripentries/" + id,
      actionInfo,
      approveTrue,
      pageType,
    ]);
  }
  goToTarget(id: string, actionInfo: number, pageType: number) {
    this.router.navigate(["/targets/" + id, actionInfo, pageType]);
  }
  goToexpenseLogs(id: number, actionInfo: number) {
    this.router.navigate(["/expenselogs/" + id, actionInfo]);
  }
  goToConsumables(id: number, actionInfo: number) {
    this.router.navigate(["/consumables/" + id, actionInfo]);
  }
  goToConsumableentries(id: string, actionInfo: number) {
    this.router.navigate(["/consumableentries/" + id, actionInfo]);
  }
  goToexpenseentries(id: number, actionInfo: number) {
    this.router.navigate(["/expenseentries/" + id, actionInfo]);
  }
  goToMakes(id: string, actionInfo: number) {
    this.router.navigate(["/makes/" + id, actionInfo]);
  }
  goToMoels(id: string, actionInfo: number) {
    this.router.navigate(["/models/" + id, actionInfo]);
  }
  goTotransfer(id: string, actionInfo: number, regNo: string) {
    this.router.navigate(["/vehicles/" + "transfer/" + id, actionInfo, regNo]);
  }
  goToIMPtransfer(
    id: string,
    actionInfo: number,
    implementserialnumber: string
  ) {
    this.router.navigate([
      "/implements/" + "transfer/" + id,
      actionInfo,
      implementserialnumber,
    ]);
  }
  goToQuickrollcall(id: number, actionInfo: number) {
    this.router.navigate(["/quickrollcall/" + id, actionInfo]);
  }

  goToQuickEntry(id: string) {
    this.router.navigate(["/quickrollcallentry/" + id]);
  }

  addFuelLogfromQuickEntry(id: number, actionInfo: number) {
    this.router.navigate(["/fuellog/" + id, actionInfo]);
  }

  goToFuelLogfromQuickEntry(id: string, actionInfo: number, vehicleid: string) {
    this.router.navigate(["/fuellog/" + id, actionInfo, vehicleid]);
  }
  goToTripEntryfromQuickEntry(
    id: number,
    actionInfo: number,
    vehicleid: number
  ) {
    this.router.navigate(["/tripentries/" + id, actionInfo, vehicleid]);
  }
  copyToTripEntryfromQuickEntry(
    id: number,
    actionInfo: number,
    pageType: number,
    vehicleid: number
  ) {
    this.router.navigate([
      "/tripentries/" + id,
      actionInfo,
      pageType,
      vehicleid,
    ]);
  }
  goToConsumableEntryfromQuickEntry(
    id: string,
    actionInfo: number,
    vehicleid: string
  ) {
    this.router.navigate(["/consumableentries/" + id, actionInfo, vehicleid]);
  }

  goToMachineryAllocate(id: string, actionInfo: number, isDepartment: boolean) {
    this.router.navigate([
      "/machineryallocate/" + id,
      actionInfo,
      isDepartment,
    ]);
  }
  goToDepartmentMachineryAllocate(
    id: number,
    actionInfo: number,
    department: number
  ) {
    this.router.navigate(["/machineryallocate/" + id, actionInfo, department]);
  }

  goToAllocateLogBook(id: number, actionInfo: number, pageType: number) {
    this.router.navigate(["/oldlogbook/" + id, actionInfo, pageType]);
  }

  goTomHireLogEntry(
    id: string,
    actionInfo: number,
    approveTrue: boolean,
    pageType: number
  ) {
    this.router.navigate([
      "/mhirelogbook/" + id,
      actionInfo,
      approveTrue,
      pageType,
    ]);
  }

  goToLogEntryfromQuickEntry(
    id: string,
    actionInfo: number,
    vehicleid: string
  ) {
    this.router.navigate(["/mhirelogbook/" + id, actionInfo, vehicleid]);
  }

  goTorefundApproval(id: string, actionInfo: number) {
    this.router.navigate(["/refundapproval/" + id, actionInfo]);
  }

  goToSettlement(
    id: string,
    regionId: string,
    divisionId: string,
    subdivisionId: string,
    actionInfo: number
  ) {
    this.router.navigate([
      "/onlinereceipts/" + id,
      regionId,
      divisionId,
      subdivisionId,
      actionInfo,
    ]);
  }

  goToPvtReceipt(
    id: string,
    regionId: string,
    divisionId: string,
    subdivisionId: string,
    actionInfo: number
  ) {
    this.router.navigate([
      "/pvtonlinereceipt/" + id,
      regionId,
      divisionId,
      subdivisionId,
      actionInfo,
    ]);
  }
  viewToAccounttransfer(
    id: string,
    regionId: string,
    divisionId: string,
    subdivisionId: string,
    actionInfo: number
  ) {
    this.router.navigate([
      "/cashreceipts/" + id,
      regionId,
      divisionId,
      subdivisionId,
      actionInfo,
    ]);
  }
  viewToDepotAccounttransfer(
    id: string,
    regionId: string,
    divisionId: string,
    subdivisionId: string,
    actionInfo: number
  ) {
    this.router.navigate([
      "/departmentreceipts/" + id,
      regionId,
      divisionId,
      subdivisionId,
      actionInfo,
    ]);
  }

  goToAccounttransfer(id: number) {
    this.router.navigate(["/cashreceipts/" + id]);
  }
  goToDepartAccounttransfer(id: number) {
    this.router.navigate(["/departmentreceipts/" + id]);
  }
  viewToTreasurytransfer(
    id: string,
    regionId: string,
    divisionId: string,
    subdivisionId: string,
    actionInfo: number
  ) {
    this.router.navigate([
      "/treasurytransfer/" + id,
      regionId,
      divisionId,
      subdivisionId,
      actionInfo,
    ]);
  }

  goToTreasurytransfer(id: number) {
    this.router.navigate(["/treasurytransfer/" + id]);
  }

  goToDepartmentBooking(id: string, actionInfo: number) {
    this.router.navigate(["/departmentbooking/" + id, actionInfo]);
  }
  goToDemoVideo() {
    this.router.navigate(["/mhiredemo"]);
  }

  goToScheme(id: string, actionInfo: number) {
    this.router.navigate(["/scheme/" + id, actionInfo]);
  }
  goToNew(id: string, actionInfo: number) {
    this.router.navigate(["/news/" + id, actionInfo]);
  }
  goToTermsandcondition(id: string, actionInfo: number) {
    this.router.navigate(["/terms/" + id, actionInfo]);
  }
  goToAddimplement(id: number, actionInfo: number) {
    this.router.navigate(["/Implement/" + id, actionInfo]);
  }
  goToVehiclecategory(id: number, actionInfo: number) {
    this.router.navigate(["/vehiclecategory/" + id, actionInfo]);
  }
  goTODealerview(id: string, actionInfo: number, viewactionInfo: number) {
    this.router.navigate(["/dealer/" + id, actionInfo, viewactionInfo]);
  }
  goTOProductMapping(id: string) {
    this.router.navigate(["/dealerproductmapping/" + id]);
  }
  gotomanufacturerlist() {
    this.router.navigate(["/manufacturerlist/"]);
  }
  gotoaeefarmerbookingview() {
    this.router.navigate(["/aeefarmerbookingview"]);
  }
  gotoFarmerTimeline(id: number) {
    this.router.navigate(["/farmerTimeLine/" + id]);
  }
  gotodivisionnew() {
    this.router.navigate(["/divisionnew"]);
  }
  goAddTarget(id: number) {
    this.router.navigate(["/targetset/" + id]);
  }
  gotoDealerManufacture() {
      // this.router.navigate(["/dealermanufacture"]);
    this.router.navigate(["/manufacturerlist"]);
  }
  goToBlockVillageMapping(id: number, actionInfo: number) {
    this.router.navigate(["/blockvillagemaping/" + id, actionInfo]);
  }

  goToViewBranch(id: number, actionInfo: number) {
    this.router.navigate(["/bankbranch/" + id, actionInfo]);
  }

  goToBranch(id: number) {
    this.router.navigate(["/bankbranch/" + id]);
  }
  goToPaacsView(id: number, actionInfo: number) {
    this.router.navigate(["/paccsbooking/" + id, actionInfo]);
  }
  goTopaccs() {
    this.router.navigate(["/paccsbooking"]);
  }
  goToPaccsInfo(id: number) {
    this.router.navigate(["/paccsinfo/" + id]);
  }

  goToPaccsReceipt(
    id: string,
    regionId: string,
    divisionId: string,
    subdivisionId: string,
    actionInfo: number
  ) {
    this.router.navigate([
      "/paccsonlinereceipt/" + id,
      regionId,
      divisionId,
      subdivisionId,
      actionInfo,
    ]);
  }
  goToCreateTicket(id: number, actionInfo: number) {
    this.router.navigate(["/ticketingsystem/" + id + "/" + actionInfo]);
  }

  goToTimelineView(id: number) {
    this.router.navigate(["/ticketingsystem/" + id]);
  }

  goToLogBook() {
    this.router.navigate(["/mhirelogbook"]);
  }
  goToPendingStatusDashboard(financialYearId: string) {
    this.router.navigate(["/ticketingsystem/pendingstatus/" + financialYearId]);
  }

  goToTicketingSystem(pendingStatusId?: string) {
    if (pendingStatusId) {
      this.router.navigate(["/ticketingsystem"], { queryParams: { pendingStatusId } });
    } else {
      this.router.navigate(["/ticketingsystem"]);
    }
  }
}
